import React from 'react';
import Icon from './Icon';

export default function MemoryInput({
  value,
  onChange,
  author,
  onAuthorChange,
  placeholder = 'Share a memory...',
  authorPlaceholder = 'Write your name...',
  className = '',
  minHeight,
  justifyBetween = false,
}) {
  return (
    <div
      className={`w-full inline-flex flex-col justify-between ${className}`}
      style={{
        padding: 24,
        background: '#FFFFFF',
        borderRadius: 20,
        outline: '1px var(--color-stroke, #B9B9B9) solid',
        outlineOffset: '-1px',
        gap: 16,
        minHeight: minHeight,
        justifyContent: justifyBetween ? 'space-between' : 'flex-start',
      }}
    >
      <textarea
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        rows={5}
        style={{
          width: '100%',
          resize: 'none',
          border: 'none',
          outline: 'none',
          fontFamily: 'Poppins',
          fontSize: 16,
          fontWeight: 400,
          color: 'var(--color-accent, #56371F)',
        }}
        className="placeholder:text-[#939393]"
      />

      <div className="inline-flex items-center gap-2">
        <Icon name="author" size={16} color="#939393" />
        <input
          type="text"
          value={author}
          onChange={(e) => onAuthorChange?.(e.target.value)}
          placeholder={authorPlaceholder}
          style={{
            border: 'none',
            outline: 'none',
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 400,
            color: '#939393',
            background: 'transparent',
            width: '100%'
          }}
          className="placeholder:text-[#939393]"
        />
      </div>
    </div>
  );
}


